import { create } from "zustand";
import ApiBaseURL from "../../utils/config";
import { GetUserAccessToken } from "../../utils/helper";
import apiList from "../../utils/apiList";
import instance from "../../api/instance.ts";
const useLapsedPolicies = create((set) => ({
  loading: false,
  error: null,
  policies: [],
  policyDetail: null,
  revivedPolicies: [],
  revivedPolicyDetail: null,
  get_LapsedPolicyListByUserId: async (data) => {
    set({ loading: true, error: null });
    try {
      const response = await ApiBaseURL.post(
        apiList.apiGetLapsedPolicyListByUserId,
        data,
        {
          headers: {
            Authorization: "Bearer " + GetUserAccessToken(),
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      set({ policies: response.data, loading: false });
    } catch (error) {
      console.error("Error:", error);
      set({ error: error.message || "Something went wrong", loading: false });
    }
  },

  get_LapsedPolicyDetailById: async (policyId) => {
    set({ loading: true, error: null });
    try {
      const token = GetUserAccessToken();
      const response = await ApiBaseURL.get(
        apiList.apiGetLapsedPolicyDetailById,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-type": "application/json; charset=UTF-8",
          },
          params: { policyId },
        }
      );
      set({ policyDetail: response.data, loading: false });
    } catch (error) {
      console.error("Error:", error);
      set({ error: error.message || "Something went wrong", loading: false });
    }
  },
  get_RevivedPolicyList: async ({ displayLength = 10, displayStart = 0 }) => {
    set({ loading: true, error: null });
    // const token = GetUserAccessToken();
    const response = await instance.post(apiList.apiGetRevivedPolicyList, {
      displayLength,
      displayStart,
    });
    set({ revivedPolicies: response.data, loading: false });
  },
  get_RevivedPolicyById: async (policyId) => {
    set({ loading: true, error: null });
    // const token = GetUserAccessToken();
    const response = await instance.get(apiList.apiGetRevivedPolicyById, {
      params: { id: policyId },
    });
    set({ revivedPolicyDetail: response.data, loading: false });
  },
}));

export { useLapsedPolicies };
